import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import CmsLayout from './CmsLayout';

export default function RenderRoutes() {
  return (
    <Switch>
      <Route path="/cms" component={CmsLayout} />
      <Redirect from="*" to="/cms" />
    </Switch>
  );
}
